import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appFilterEngine]'
})
export class FilterEngineDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
